'use client';

import clsx from 'clsx';
import { useEffect, useState } from 'react';

import styles from './ProgressBar.module.scss';

// Type definition for the ProgressBar component properties.

type Props = {
  className?: string;
};

/**
 * ProgressBar component.
 *
 * Renders an horizontal bar that shows the current scroll progress.
 */

const ProgressBar = ({ className }: Props) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const contentWrapper = document.querySelector('#content-wrapper') as HTMLElement;
      if (!contentWrapper) return;

      // Get the bottom position of content-wrapper relative to the page
      const contentBottom = contentWrapper.getBoundingClientRect().bottom + window.scrollY;

      const currentScroll = window.scrollY;

      // Offset to make it end when the section reaches the middle of the screen
      const offset = window.innerHeight / 2;

      // Total scrollable area from the top of the page to the middle of content-wrapper
      const totalScrollableHeight = contentBottom - window.innerHeight + offset;

      const progressPercentage = (currentScroll / totalScrollableHeight) * 100;

      setProgress(progressPercentage);
    };

    // Trigger calculation on mount in case the user is already scrolled
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const classes = clsx(styles.progressBar, 'progress-bar', className);

  return (
    <div className={classes}>
      <div className={styles.activePart} style={{ width: `${Math.min(100, progress)}%` }}></div>
    </div>
  );
};

export default ProgressBar;
